import React from "react";
export const AdditionalOfferContainerRefContext =
	React.createContext<HTMLDivElement | null>(null);
